import React, { useEffect, useState, useRef } from "react";
import { getChannelStatistics } from "../../api/youtubeApi";
import "./YoutubeAnalytics.css";

const YoutubeAnalytics = () => {
    const [stats, setStats] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    // Mock percentage for "Not Subscribed" users (Persuasive Graph)
    const NOT_SUBSCRIBED_PERCENTAGE = 78;

    useEffect(() => {
        const fetchStats = async () => {
            const data = await getChannelStatistics();
            if (data) setStats(data);
        };
        fetchStats();
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
    }, []);

    const formatCount = (count) => {
        if (!count) return "0";
        return parseInt(count).toLocaleString();
    };

    return (
        <div className="youtube-analytics-container" ref={sectionRef}>
            <div className="youtube-card" data-aos="fade-up">
                <div className="youtube-header">
                    <h2>YouTube Analytics</h2>
                    <p className="join-text">Join our growing community!</p>
                </div>

                <div className="analytics-visual">
                    <p style={{ fontSize: "1rem", marginTop: "15px", maxWidth: "600px", lineHeight: "1.5" }}>
                        <strong>{NOT_SUBSCRIBED_PERCENTAGE}%</strong> of people watch our videos but haven't subscribed yet. Please <strong>hit the subscribe button</strong> and press the <strong>bell icon</strong> for the latest updates.
                    </p>
                </div>

                <div className="subscribe-cta">
                    <p className="join-text">Till now our subscriber family is:</p>
                    <h3 className="subscriber-count">
                        {stats ? formatCount(stats.subscriberCount) : "Loading..."}
                    </h3>
                    <p className="join-text" style={{ marginTop: "10px" }}>
                        Our target to hit <strong>100k</strong>
                    </p>

                    <a
                        href="https://www.youtube.com/channel/UCQyqh-TuRIgqGM6-6pG9pag?sub_confirmation=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="subscribe-btn animate-pulse"
                    >
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
                        </svg>
                        Subscribe Now
                    </a>
                </div>
            </div>
        </div>
    );
};

export default YoutubeAnalytics;
